import { render } from "./section-4.vue?vue&type=template&id=656914fa&scoped=true"
import script from "./section-4.vue?vue&type=script&lang=js"
export * from "./section-4.vue?vue&type=script&lang=js"

import "./section-4.vue?vue&type=style&index=0&id=656914fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656914fa"]])

export default __exports__